import { render, staticRenderFns } from "./employerJobDetails.vue?vue&type=template&id=aa147a9e"
import script from "./employerJobDetails.vue?vue&type=script&lang=js"
export * from "./employerJobDetails.vue?vue&type=script&lang=js"
import style0 from "./employerJobDetails.vue?vue&type=style&index=0&id=aa147a9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports